import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Safearea } from "../UI/Safearea/Safearea";
import { Row, Col } from "../UI/Customstrap/Customstrap";
import { Container } from "../UI/Container/Container";
import { Table } from "reactstrap";
import data from "../../../ver.json";
import { fetchCorexBuildVersion, fetchApiBuildVersion } from "../../services/api/entities";
import { getSession, getCurrentAccount, getTexts } from "../../reducers/selectors";
import calendar from "../../../public/svg/calendar.svg";
import advisorIcon from "../../../public/svg/advisor.svg"
import { Icons } from "../UI/Icon/Icon";

import style from "./Help.scss";

export const Help = ({toggleHelp}) => {
  const currentAccount = useSelector(getCurrentAccount);
  const texts = useSelector(getTexts);
  const [corexVersion, setCorexVersion] = useState();
  const [apiVersion, setApiVersion] = useState();

  useEffect(() => {
    fetchCorexBuildVersion()
      .then((res) => {
        setCorexVersion(res.response.currentBuildVersion);
      })
      .catch((err) => {
        console.error(err);
      });
    fetchApiBuildVersion()
      .then((res) => {
        setApiVersion(res.response.version);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const initials = `${currentAccount.advisorName.substring(
    0,
    1
  )}${currentAccount.advisorFirstLastName.substring(0, 1)}`;

  return (
    <div className={style.subAssetClassDisplay}>
      <Row>
        <Col xs={12} className={style.titleWrapper}>
          <span className={style.iconWrapper} onClick={toggleHelp}>
            <Icons.ArrowLeftIcon className={style.icon}/>
          </span>
          <span className={style.title}>Ayuda</span>
        </Col>
        <hr />
      </Row>
      <Row>
        <Col>
          <Container className={style.boxInfo}>
            <div className={style.titleInfo}>Informaciones y consultas generales: </div>
            <div className={style.boxTable}>
              <Table className={style.table}>
                <tbody>
                  <tr>
                    <td>
                      <p>Teléfono: </p>
                      <p className={style.tdInfo}>{currentAccount.companyPhone}</p>
                    </td>
                    <td>
                      <p>Correo: </p>
                      <p className={style.tdInfo}>{currentAccount.companyEmail}</p>
                    </td>
                    <td>
                      <p>Ubicación: </p>
                      <p className={style.tdInfo}>{currentAccount.companyLocation}</p>
                    </td>
                    <td>
                      <p>Horario: </p>
                      <p className={style.tdInfo}>{currentAccount.companyOpeningHours}</p>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Container>
        </Col>
      </Row>
      <Row>
        <Col>
          <Container className={style.boxAdvisor}>
            <div className={style.advisor}>
              <img src={advisorIcon}/>
              <p>Mi asesor</p>
            </div>
            <div className={style.wrapperTableAdvisor}>
              <Table className={style.tableAdvisor}>
                  <tbody>
                    <tr>
                      <td>
                        <p>Nombre: </p>
                        <p className={style.tdInfo}>{`${currentAccount.advisorName} ${currentAccount.advisorFirstLastName}`}</p>
                      </td>
                      <td>
                        <p>Teléfono: </p>
                        <p className={style.tdInfo}>{currentAccount.advisorPhone}</p>
                      </td>
                      <td>
                        <p>Correo: </p>
                        <p className={style.tdInfo}>{currentAccount.advisorEmail}</p>
                      </td>
                    </tr>
                  </tbody>
                </Table>
            </div>
          </Container>
        </Col>
      </Row>
    </div>
  );
};
